<template>
  <div class="col border border-3">
    Départ en cours de séance à
    {{ $moment(toLocalTime(event.date)).locale("fr").format("HH[h]mm") }},
    {{ getPersonName({ personId: event.building_owner_id }) }} ({{
      getUsedMandateTantiemesChargeGenerale(event.mandate_id)
    }}), après la résolution n°{{ voteOrder }}.
    <appPresenceChanges
      v-if="event.new_presence_status == mandatePresenceStatuses.not_present"
      :event="event"
    />
  </div>
</template>

<script>
import appPresenceChanges from "./snippets/presenceChanges.vue";

import { mandatePresenceStatuses } from "@/constants/mandate.js";

export default {
  components: {
    appPresenceChanges,
  },
  props: ["event", "voteOrder"],
  data() {
    return {
      mandatePresenceStatuses,
    };
  },
};
</script>
